import Vue from 'vue';

const initialState = () => ({
  activeTables: 0,
  documentTemplatesChanged: false,
});

export const mutations = {
  SET_DOCUMENT_TEMPLATES_CHANGED(state, changed) {
    state.documentTemplatesChanged = changed;
  },

  SET_ACTIVE_TABLE(state, increase = true) {
    state.activeTables += (increase ? 1 : -1);
  },
};

export const actions = {

  notifyTables({ state, commit }) {
    if (state.activeTables > 0) {
      commit('SET_DOCUMENT_TEMPLATES_CHANGED', true);
    }
  },

  async resetDocumentTemplatesChanged({ commit }) {
    // wait one tick to ensure that all active components are notified
    await Vue.nextTick();
    commit('SET_DOCUMENT_TEMPLATES_CHANGED', false);
  },

  addActiveTable({ commit }) {
    commit('SET_ACTIVE_TABLE', true);
  },

  removeActiveTable({ commit }) {
    commit('SET_ACTIVE_TABLE', false);
  },

};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
};
